import { authorizedApi } from './index';

export const metricsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    getMetrics: builder.mutation({
      query: ({ startDate, endDate }) => ({
        url: `/admin/metrics`,
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetMetricsMutation } = metricsApi;
